// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonDashboardPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {

  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var connect = require('share/enhancers/Izenda.Connect');
  const { assign, omit } = require('lodash/fp');

  module.exports = function(displayName, propTypes) {
    return connect()(
      React.createClass({
        displayName: displayName,
        propTypes: assign(
          {
            Content: React.PropTypes.func,
            constants: React.PropTypes.object
          },
          propTypes
        ),

        /**
         * Handle close popup.
         * @param {Object} cb: callback function
         * @param {String} type
         */
        onClosing: function(cb, type) {
          var props = this.props;
          var content = this.refs.content;
          content.onClosing && content.onClosing(type);
        },

        render: function() {
          var props = this.props;
          var Content = props.Content;
          var contentPros = omit(['Content', 'constants'], props);
          var localization = props.localization;

          return (
            <Popup visible onClosing={this.onClosing} type="none" autoClose={false} sizeClass="modal-lg">
              <Popup.Header title={props.constants.TITLE} />
              <Popup.Body>
                <Content ref="content" {...contentPros} />
              </Popup.Body>
              <Popup.Footer>
                <Popup.ConfirmationButton type="accept">
                  {localization.getText('COMMON_LABEL_OK')}
                </Popup.ConfirmationButton>
                <Popup.ConfirmationButton type="cancel">
                  {localization.getText('COMMON_LABEL_CANCEL')}
                </Popup.ConfirmationButton>
              </Popup.Footer>
            </Popup>
          );
        }
      })
    );
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/Izenda.CommonDashboardPopup.jsx